import { formatBytes } from '@lib/utils/units'

import type { Size } from '@/types/models'
import type { Offset } from '@/utils/offset'

export const DEFAULT_PROJECT_NAME = 'Untitled project'

export const BASE_COLOR_CLOUDY = {
  id: 'cloudy',
  title: 'Cloudy',
  hexCode: '#ACBDD3',
}
export const COLOR_YELLOW = '#fefa6c'
export const COLOR_CYAN = '#c5f1ff'
export const COLOR_CRIMSON = '#ffd2fb'
export const COLOR_CORAL = '#EA5E5E'
export const COLOR_TOPAZ = '#18C4A9'
export const COLOR_ORANGE = '#F8AB4B'
export const COLOR_BLUE = '#2F7FEF'
const COLOR_LIGHT_BLUE = '#68A5FB'
const COLOR_BOLD_BLUE = '#2D3A55'
export const COLOR_MAGENTA = '#EB60BC'
export const COLOR_PURPLE = '#AA5EEA'
export const COLOR_DUSK = '#768BA7'

export const TREE_DEFAULT = 'map'
export const TREE_MATRIX = 'matrix'
export const COLOR_WHITE = '#ffffff'
export const COLOR_WHITE_SHORT = '#fff'

export const STICKY_NOTE_OFFSET: Offset = { x: 0, y: 0 }
export const STICKY_NOTE_SIZE: Size = { width: 128, height: 119 }
export const NODE_DEFAULT = 'default'
export const NODE_FRAME = 'frame'
export const NODE_GHOST = 'ghost'
export const NODE_STACK = 'stack'
export const THEME_DARK = 'dark'
export const THEME_LIGHT = 'light'
export const THEME_BLUEPRINT = 'blueprint'
export const THEME_BOLD = 'bold'
export const STATUS_ACTIVE = 'Active'
/** Written by octopus-api while Stripe retries a declined card: the plan is
 * still on, the renewal has not been paid. OCT-5150. */
export const STATUS_PAST_DUE = 'PastDue'
export const ERROR_USER_NOT_FOUND = 'USER_NOT_FOUND'
export const ERROR_LIMIT_REACHED = 'LIMIT_REACHED'
const ERROR_FIGMA_ACCOUNT_OWNER = 'FIGMA_ACCOUNT_OWNER'
export const ERROR_INVALID_PLAN = 'INVALID_PLAN'
export const ERROR_TYPES = [
  ERROR_USER_NOT_FOUND,
  ERROR_LIMIT_REACHED,
  ERROR_INVALID_PLAN,
  ERROR_FIGMA_ACCOUNT_OWNER,
]

// @TODO to be removed after refactoring API service
export const MENTION_TYPE_PAGE = 'mentionPage'
export const MENTION_TYPE_BLOCK = 'mentionBlock'
const MENTION_TYPE_STICKY_NOTE = 'mentionStickyNote'
export const MENTION_TYPES = [
  MENTION_TYPE_PAGE,
  MENTION_TYPE_BLOCK,
  MENTION_TYPE_STICKY_NOTE,
]

export const MAX_CANVAS_RESOLUTION =
  navigator.userAgent.search('Firefox') > -1 ? 19992 : 14384

export const EXPORT_CANVAS_PADDING = 150

export const DEFAULT_TITLE =
  'Octopus.do, Visual Sitemap Tool, Website Planner, Architecture'

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export const DAY_MONTH_YEAR = 'DD-MM-YYYY'
export const HOUR_MINUTE_AM_PM = 'HH:MM XM'

export const REQUEST_ATTACHMENTS_TIMEOUT = 15 * 60 * 1000 // 15min
export const REQUEST_USER_LIMITS_TIMEOUT = 15 * 60 * 1000 // 15min

export const STORAGE_LIMITS = {
  hMax: formatBytes(0),
  hUsage: formatBytes(0),
  max: 0,
  usage: 0,
  percentageUsage: 0,
}

export const PASSWORD_REGEX = /^(?=.*[0-9]).{8,}$/

export const PASSWORD_WITHOUT_LIMIT_REGEX = /^(?=.*[0-9]).*$/

export const EMAIL_REGEX =
  /^(([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{0,64}(\.[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{0,64})*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const ACCEPTED_FILE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
]

export const colorSets: Record<string, Record<string, string>> = {
  [COLOR_BLUE]: {
    [THEME_BOLD]: COLOR_BOLD_BLUE,
    [THEME_DARK]: COLOR_LIGHT_BLUE,
    [THEME_LIGHT]: COLOR_BLUE,
    [THEME_BLUEPRINT]: COLOR_BLUE,
  },
  [COLOR_LIGHT_BLUE]: {
    [THEME_BOLD]: COLOR_BOLD_BLUE,
    [THEME_DARK]: COLOR_LIGHT_BLUE,
    [THEME_LIGHT]: COLOR_BLUE,
    [THEME_BLUEPRINT]: COLOR_BLUE,
  },
  [COLOR_BOLD_BLUE]: {
    [THEME_BOLD]: COLOR_BOLD_BLUE,
    [THEME_DARK]: COLOR_LIGHT_BLUE,
    [THEME_LIGHT]: COLOR_BLUE,
    [THEME_BLUEPRINT]: COLOR_BLUE,
  },
  [COLOR_TOPAZ]: {
    [THEME_BOLD]: '#00C4B7',
    [THEME_DARK]: COLOR_TOPAZ,
    [THEME_LIGHT]: COLOR_TOPAZ,
    [THEME_BLUEPRINT]: COLOR_TOPAZ,
  },
  [COLOR_ORANGE]: {
    [THEME_BOLD]: '#FF8934',
    [THEME_DARK]: COLOR_ORANGE,
    [THEME_LIGHT]: COLOR_ORANGE,
    [THEME_BLUEPRINT]: COLOR_ORANGE,
  },
  [COLOR_CORAL]: {
    [THEME_BOLD]: '#F45454',
    [THEME_DARK]: COLOR_CORAL,
    [THEME_LIGHT]: COLOR_CORAL,
    [THEME_BLUEPRINT]: COLOR_CORAL,
  },
}
